<template>
  <section class="section">
    <header class="calendar admin-calendar static">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <div class="date-picker">
            <div class="date-picker-dates owl-carousel" id="calendar_admin" ref="calendar_admin">
            <div class="item" v-for="dia, idx in dias" :class="{current: idx === idxDiaActivo}" :key="idx">
              <a @click.prevent="setDiaActivo(idx)" href="#" class="cutoff-date-option">
              <div class="date">
                <div class="day-of-week mobile">
                {{dia | diaNombreMobile}}
                </div>
                <div class="day-of-week desktop">
                {{dia | diaNombreDesktop}}
                </div>
                <div class="day-of-month">
                {{dia | diaFormateado}}
                </div>
              </div>
              </a>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header><!-- fin Header Calendario -->
  <header class="static">
    <div class="container">
      <ul class="tabs-manager">
        <li v-for="estado, idx in estados" :class="{active: idxEstadoActivo === idx}" v-if="estado.titulo">
          <a @click.prevent="setEstadoActivo(idx)" href="#">
            {{estado.titulo}}
          </a>
        </li>
        <!-- <li :class="{active: verResumen}"><a @click="verResumen = !verResumen">Resumen</a></li> -->
      </ul>
    </div>
  </header><!-- fin Header gestion en tabs -->
  <section class="section manager-content">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-2 aside-manager">
            <div class="box-aside line-top smart-form">
              <div class="box-header-lg">
                <i class="icon-stats"></i><h1> RESUMEN</h1>
              </div>
              <div class="box-aside-body resume stats">
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number pending">{{contadorPedidosPendientes}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Pedidos<br/>Pendientes</span>
                    </div>
                  </div>
                </div>
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number oncourse">{{contadorPedidosEnCurso}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Pedidos<br/>en Curso</span>
                    </div>
                  </div>
                </div>
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number process">{{contadorPedidosProcesados}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Pedidos<br/>Procesados</span>
                    </div>
                  </div>
                </div>
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number process">{{contadorPedidosDespachados}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Pedidos<br/>Despachados</span>
                    </div>
                  </div>
                </div>
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number canceled">{{contadorPedidosCancelados}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Pedidos<br>Cancelados</span>
                    </div>
                  </div>
                </div>
              </div> 
              <div class="box-aside-body resume-total">
                <h3 class="total-number">{{montoTotalEntregas | formatearMoneda}}</h3>
                <span class="total-label">Total del día</span>
              </div>
              <div class="box-aside-body text-center">
                <a class="btn btn-fill" data-toggle="modal" data-target="#comanda-general">Comanda del día</a>
              </div>
              <div class="box-aside-body text-center">
                <a class="btn btn-outline-grey-green"  @click="verResumen = !verResumen">Mostrar resumen</a>
              </div>
            </div>
            <router-link class="btn-link margin-top-10 deco-dotted pull-left" to="/historicoentregas">Ver histórico de entregas</router-link>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-9 col-lg-10">
            <div class="box-style line-top smart-form">
              <div class="box-header-lg">
                <h1>ENTREGAS {{estados[idxEstadoActivo].text | toUpper}} PARA LA FECHA</h1>
                <div class="box-header-aside bha-selector">
                  <label>EMPRESA</label>
                  <div class="select form-ghost">
                    <select class="form-control" v-model="empresaActiva" ref="selectEmpresa">
                      <option value="-1">TODAS LAS EMPRESAS</option>
                      <option :value="empresa._id" v-for="empresa in empresas" :key="empresa._id">{{empresa.text}}</option>
                    </select>
                    <i class="fa fa fa-angle-down"></i>
                  </div>
                </div>
              </div>
              <div class="panel-body">
                <div v-show="verResumen">
                  <div ref="contenedorPivor" ></div>
                  <button class="btn btn-default" @click="printPivot()">Imprimir</button>
                  <div class="pull-right">
                    <button class="btn btn-fill" @click="verResumen=false">Esconder resumen</button>
                  </div>
                </div>
                <div class="table-header form smart-form" v-show="!verResumen">
                  <div class="form-group col-hactions col1">
                    <label class="label-lg"><i class="icon-status"></i> Cambiar estados</label>
                    <div class="col-action">
                      <!-- <select-estados  :estadoorigen="estadoActivo"></select-estados> -->
                      <select class="form-control" :value="estadoActivo" @change="onChangeEstadoSeleccionados">
                        <option :value="estado.id" v-for="estado in estados" :key="estado._id">{{estado.text}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-hactions col2">
                    <label class="label-lg"><i class="icon-export"></i> Exportar lista</label>
                    <div class="col-action">
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                          EXCEL  <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a @click.prevent="entregasSeleccionadasAXls()">Descargar selección</a>
                          </li>
                          <li>
                            <a @click.prevent="entregasListadoAXls()">Descargar todo el listado</a>
                          </li>
                        </ul>
                      </div>
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                           PDF <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a @click.prevent="entregasSeleccionadasAPdf()">Descargar selección</a>
                          </li>
                          <li>
                            <a @click.prevent="entregasListadoAPdf()">Descargar todo el listado</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-hactions col3">
                    <label class="label-lg"><i class="icon-print"></i> Imprimir</label>
                    <div class="col-action">
                        <div class="button">
                          <a @click.prevent="entregasAEtiquetas(entregasSeleccionadas)" style="border-bottom-width: 3px;" class="btn btn-outline-grey-green">COMANDAS</a>
                        </div>
                        <div class="button">
                          <a @click.prevent="entregasAEtiquetas(entregasSeleccionadas)" style="border-bottom-width: 3px;" class="btn btn-outline-grey-green">ETIQUETAS</a>
                        </div>
                      </div>
                  </div>

                  <div class="form-group col-hactions col4 withoutFloat">
                    <label class="label-lg"><i class="icon-listview"></i> Filtrar</label>
                        <select class="form-control" v-model="filtroRestricciones">
                          <option value="ALL" selected>Todos</option>
                          <option value="RESTRICTIONS">Con Restricciones</option>
                        </select>
                  </div>

                  <!--
                  <div class="form-group col-hactions col4">
                    <label class="label-lg"><i class="icon-listview"></i> Resumen</label>
                    <div class="col-action">
                        <select class="form-control" onchange="location = this.value;">
                          <option value="pedidos_pendientes.html" selected>Listado por hora</option>
                          <option value="pedidos_pendientes-listmenu.html">Listado por menú</option>
                        </select>
                        <i class="fa fa fa-angle-down"></i>
                      </div>
                      <a class="btn btn-outline-grey-green"  @click="verResumen = !verResumen">Mostrar resumen</a>
                    </div>
                  </div>
                  -->
                </div>
              </div>
                <div class="panel-group smart-accordion-default" id="accordion">
                  <div class="panel panel-time" v-for="entregas, idx, a in entregasActivasAgrupadasHora" :key="a">
                    <div class="panel-heading">
                      <div class="panel-title box-header">
                        <a data-toggle="collapse" :href="'#pnl-' + a">
                          <i class="fa fa-lg fa-angle-down pull-right"></i>
                          <i class="fa fa-lg fa-angle-up pull-right"></i>
                          <h2><b>{{idx}}hs</b></h2>
                        </a>
                      </div>
                    </div>
                    <div :id="'pnl-' + a" class="panel-collapse collapse in">
                      <div class="panel-body">
                        <div class="table-container">
                          <table class="table table-hover table-stripped table-manager-time">
                            <thead>
                              <tr>
                                <th>
                                  <div class="smart-form">
                                    <label class="checkbox">
                                      <input type="checkbox" :id="'selectable' + a" class="selectable" @click="marcarTodos(idx, $event)" >
                                      <i></i>
                                    </label>
                                  </div>
                                </th>
                                <th>Empresa</th>
                                <th>Nro.</th>
                                <th>Usuario</th>
                                <th>Menú</th>
                                <th>Estado</th>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="entrega in entregas" :key="entrega._id" class="deliveryRow" :class="{deliveryRestrictions:entrega.usuario.other||entrega.usuario.alergic||entrega.usuario.vegan||entrega.usuario.vegetarian}">
                                <td>
                                  <div class="smart-form">
                                    <label class="checkbox">
                                      <input type="checkbox" class="selectable" v-model="entrega.seleccionada" @change="toggleSeleccion(entrega._id)" >
                                      <i></i>
                                    </label>
                                  </div>
                                </td>
                                <td>{{entrega.sucursal.empresa.razonSocial}}-{{entrega.sucursal.denominacion}}</td>
                                <td>{{entrega.numero}}</td>
                                <td>{{entrega.usuario.displayName}}</td>
                                <td>
                                  <i title="Tiene restricciones alimenticias" class="fa fa-ban" v-if="entrega.usuario.other||entrega.usuario.alergic||entrega.usuario.vegan||entrega.usuario.vegetarian"></i>
                                  <span class="truncate">{{entrega.platosSerialized}}</span>
                                </td>
                                <td class="td-status">
                                  <select-estados @change-estado="onChangeItemEstado" :identrega="entrega._id" :estadoorigen="entrega.estado"></select-estados>
                                </td>
                                <td>
                                  <!--
                                  <ul class="table-actions smart-form">
                                    <li>
                                      <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" role="tooltip" rel="tooltip" data-placement="top" title="Exportar en Excel">
                                        <i class="fa fa-actions fa-file-excel-o"></i>
                                      </a>
                                    </li>
                                    <li>
                                      <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" role="tooltip"  rel="tooltip" data-placement="top" title="Exportar en PDF">
                                        <i class="fa fa-actions fa-file-pdf-o"></i>
                                      </a>
                                    </li>
                                    <li>
                                      <a  class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Imprimir comanda">
                                        <i class="fa fa-actions fa-print"></i>
                                      </a>
                                    </li>
                                    <li>
                                      <a class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Imprimir etiqueta">
                                        <i class="fa fa-actions fa-ticket"></i>
                                      </a>
                                    </li>
                                  </ul>
                                  -->
                                </td>
                                <td>
                                <a @click="abrirComanda(entrega)" type="button" class="btn btn-outline btn-xsw pull-right">DETALLE</a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center center-block placeholder" v-if="entregasActivasAgrupadasHora.length === 0">
                  <h1>No hay pedidos en estado {{estados[idxEstadoActivo].text}} para esta fecha</h1>
                </div>
            </div>
            
          </div>
        </div>
      </div>
    </section><!-- Fin contenedor de menú diario -->
    <div class="modal fade detalle-pedido" id="detalle-pedido" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document" v-if="entregaComanda">
      <div class="modal-content">
        <div class="modal-body" >
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h2>Comanda #{{entregaComanda.numero}}</h2>
        <p class="size-16">
          Fecha y hora: <span class="semibold">{{entregaComanda.fechaEntrega | fechaComanda}}</span><br/>
          Empresa: <span class="semibold">{{ entregaComanda.sucursal.empresa.razonSocial }} - {{ entregaComanda.sucursal.denominacion }}</span><br/>
          Empleado: <span class="semibold">{{entregaComanda.usuario.displayName}}</span><br/>
          <span class="deliveryModalRestrictions" v-if="entregaComanda.usuario.other||entregaComanda.usuario.alergic||entregaComanda.usuario.vegan||entregaComanda.usuario.vegetarian">
            <h4>TIENE RESTRICCIONES ALIMENTICIAS</h4>
            <span class="text-danger" v-if="entregaComanda.usuario.vegan"><i class="icon-vegan"></i> Vegano</span>
            <span class="text-danger" v-if="entregaComanda.usuario.vegetarian"><i class="icon-vegetarian"></i> Vegetariano</span>
            <span class="text-danger" v-if="entregaComanda.usuario.celiac"><i class="icon-celiac"></i> Sin gluten</span>
            <span class="text-danger" v-if="entregaComanda.usuario.other"><i class="icon-menu-config"></i> Otros</span>
            <span class="text-danger" v-if="entregaComanda.usuario.alergic"><i class="icon-spice"></i> Alérgico</span>
            <br/>
            <br/>
            <span class="text-danger" v-if="entregaComanda.usuario.other||entregaComanda.usuario.alergic">
              {{entregaComanda.usuario.restrictions}}
            </span>
          </span>
        </p>
        <ul class="order-list">
          <li v-for="plato in entregaComanda.platos" :key="plato._id"><span>{{plato.cantidad}}x</span> {{plato.plato.nombre}}</li>
        </ul>
      
        </div>
      </div>
      </div>
    </div><!-- Fin modal comanda-->
    <div class="modal fade" id="comanda-general" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body" id="body-comanda">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h2>Comanda general {{diaActivo | diaFormateado}}</h2>
            <template v-for="item, idx in comandaDelDia">
              <h3>{{idx}}</h3>
              <ul class="order-list">
                <li v-for="plato in item" :key="plato._id">
                  <span>{{plato.cantidad}}x</span> {{plato.plato.nombre}}
                </li>
              </ul>
            </template>
          </div>
          <div class="modal-footer">
            <div class="pull-right">
              <button @click.prevent="imprimirComandaGeneral" class="btn btn-fill">Imprimir</button>
            </div>
          </div>
        </div>
      </div>
    </div><!-- Fin modal comanda-->
    <iframe id="ifmcontentstoprint" style="height: 0px; width: 0px; position: absolute"></iframe>
    <div class="hidden" ref="contenedorExport"></div>
    <div id="contenedorEtiquetas"></div>
  </section>
</template>
  
<script>
  import $ from 'jquery'
  import '../../assets/css/admin.css'
  import '../../assets/js/jquery-ui.min.js'
  import '../../assets/css/jquery-ui.min.css'
  import 'pivottable/dist/pivot.css'
  import 'pivottable'
  import 'animate.css'
  import clasesAdmin from '../../mixins/ClasesAdmin'
  import 'owl.carousel/dist/assets/owl.carousel.css'
  import 'owl.carousel'
  import moment from 'moment'
  import selectEstados from './ComboEstados'
  import _ from 'lodash'
  import JsPDF from 'jspdf'
  import 'jspdf-autotable'
  import PHE from 'print-html-element'
  import TableExport from 'tableexport'
  // import 'sweetalert2/dist/sweetalert2.css'
  // import swal from 'sweetalert2'
  
  export default {
    mixins: [clasesAdmin],
    components: {
      'select-estados': selectEstados
    },
    computed: {
      comandaDelDia () {
        const me = this
        let filtradas = me.entregasActivas.filter((entrega) => {
          return entrega.estado !== 'Cancelado'
        })
        let sum = []
        filtradas.forEach((entrega) => {
          entrega.platos.forEach((plato) => {
            let existePlato = sum.find((platoSum) => {
              return platoSum._id === plato.plato._id
            })
            if (existePlato) {
              existePlato.cantidad += plato.cantidad
            } else {
              sum.push({
                _id: plato.plato._id,
                plato: plato.plato,
                cantidad: plato.cantidad
              })
            }
          })
        })
        return _.groupBy(sum, (item) => {
          return item.plato.categoria.nombre
        })
      },
      contadorPedidosDespachados () {
        const me = this
        let filtradas = me.entregasActivas.filter((entrega) => {
          return entrega.estado === me.estados[3].id
        })
        return filtradas.length
      },
      contadorPedidosCancelados () {
        const me = this
        let filtradas = me.entregasActivas.filter((entrega) => {
          return entrega.estado === me.estados[4].id
        })
        return filtradas.length
      },
      contadorPedidosPendientes () {
        const me = this
        let filtradas = me.entregasActivas.filter((entrega) => {
          return entrega.estado === me.estados[0].id
        })
        return filtradas.length
      },
      contadorPedidosEnCurso () {
        const me = this
        let filtradas = me.entregasActivas.filter((entrega) => {
          return entrega.estado === me.estados[1].id
        })
        return filtradas.length
      },
      contadorPedidosProcesados () {
        const me = this
        let filtradas = me.entregasActivas.filter((entrega) => {
          return entrega.estado === me.estados[2].id
        })
        return filtradas.length
      },
      contadorSeleccionados () {
        const me = this
        let contador = 0
        me.entregasActivas.forEach((entrega) => {
          if (entrega.seleccionada) {
            contador += 1
          }
        })
        return contador
      },
      montoTotalEntregas () {
        const me = this
        let acumulador = 0
        let filtradas = me.entregasActivas.filter((entrega) => {
          let fechaEntregaFormateada = moment(new Date(entrega.fechaEntrega)).utc().format('DD/MM/YYYY')
          let fechaActivaFormateada = moment(new Date(me.diaActivo)).utc().format('DD/MM/YYYY')
          return fechaEntregaFormateada === fechaActivaFormateada && entrega.estado !== 'Cancelado'
        })
        filtradas.forEach((entrega) => {
          acumulador += entrega.montoTotal
        })
        return acumulador
      },
      entregasActivas () {
        const me = this
        let filtradas = me.entregasDia
        if (me.empresaActiva !== '-1') {
          filtradas = filtradas.filter((entrega) => {
            return entrega.sucursal._id === me.empresaActiva
          })
        }
        if (me.filtroRestricciones !== 'ALL') {
          filtradas = filtradas.filter((entrega) => {
            return entrega.usuario.celiac || entrega.usuario.vegan || entrega.usuario.vegetarian || entrega.usuario.alergic || entrega.usuario.other
          })
        }
        filtradas = _.sortBy(filtradas, ['numero'], [false])
        return filtradas
      },
      entregasActivasAgrupadasHora () {
        const me = this
        let entregas = []
        if (me.entregasActivasEstado.length > 0) {
          entregas = _.groupBy(me.entregasActivasEstado, (entrega) => {
            return entrega.horaEntrega
          })
        }
        return entregas
      },
      entregasActivasEstado () {
        const me = this
        let filtradas = me.entregasActivas.filter((entrega) => {
          return entrega.estado === me.estadoActivo
        })
        return filtradas || []
      },
      entregasDia () {
        const me = this
        let filtradas = []
        filtradas = me.entregas.filter((entrega) => {
          let fechaEntregaFormateada = moment(new Date(entrega.fechaEntrega)).utc().format('DD/MM/YYYY')
          let fechaActivaFormateada = moment(new Date(me.diaActivo)).utc().format('DD/MM/YYYY')
          return fechaEntregaFormateada === fechaActivaFormateada
        })
        let ordenadas = filtradas.sort((a, b) => {
          if (a.horaEntrega > b.horaEntrega) {
            return 1
          }
          if (a.horaEntrega < b.horaEntrega) {
            return -1
          }
          return 0
        })
        return ordenadas
      },
      entregasFila () {
        const me = this
        let resultados = []
        me.entregasActivas.forEach((entrega) => {
          entrega.platos.forEach((plato) => {
            resultados.push({
              empresa: entrega.sucursal.empresa.razonSocial + ' ' + entrega.sucursal.denominacion,
              dia: moment(new Date(entrega.fechaEntrega)).utc().format('DD/MM/YYYY'),
              hora: entrega.horaEntrega,
              plato: plato.plato.nombre,
              cantidad: plato.cantidad,
              usuario: entrega.usuario.displayName,
              estado: entrega.estado
            })
          })
        })
        return resultados
      },
      entregasSeleccionadas () {
        const me = this
        let entregas = []
        entregas = me.entregasActivas.filter((entrega) => {
          return entrega.seleccionada
        })
        return entregas
      }
    },
    filters: {
      diaNombreDesktop (value) {
        return moment(new Date(value)).utc().format('ddd')
      },
      diaNombreMobile (value) {
        return moment(new Date(value)).utc().format('dd')
      },
      diaNumero (value) {
        return moment(new Date(value)).utc().format('DD')
      },
      diaFormateado (value) {
        return moment(new Date(value)).utc().format('DD/MM/YYYY')
      },
      fechaComanda (value) {
        return moment(value).format('dddd DD/MM/YYYY HH:mm [hs]')
      },
      formatearMoneda (value) {
        return '$ ' + parseFloat(value).toFixed(2)
      },
      toLower (value) {
        if (!value) return ''
        return value.toLoweCase()
      },
      toUpper (value) {
        if (!value) return ''
        return value.toUpperCase()
      }
    },
    data () {
      return {
        dias: [],
        diaActivo: undefined,
        filtroRestricciones: 'ALL',
        empresaActiva: '-1',
        empresas: [],
        entregas: [],
        // estados: [
        //   {titulo: 'PEDIDOS PENDIENTES', estado: 'Recibido'},
        //   {titulo: 'PEDIDOS EN CURSO', estado: 'Cocina'},
        //   {titulo: 'PEDIDOS PROCESADOS', estado: 'Empaquetado'},
        //   {titulo: 'PEDIDOS CANCELADOS', estado: 'Cancelado'}
        // ],
        estadosHacia: {
          Recibido: ['Cocina', 'Cancelado'],
          Cocina: ['Empaquetado', 'Cancelado', 'Recibido'],
          Empaquetado: ['Despachado', 'Cancelado', 'Cocina'],
          Despachado: ['Cancelado']
        },
        estados: [
          {text: 'Pendiente', id: 'Recibido', class: 'pending', titulo: 'PEDIDOS PENDIENTES'},
          {text: 'En curso', id: 'Cocina', class: 'oncourse', titulo: 'PEDIDOS EN CURSO'},
          {text: 'Procesado', id: 'Empaquetado', class: 'process', titulo: 'PEDIDOS PROCESADOS'},
          {text: 'Despachado', id: 'Despachado', class: 'payment-pending', titulo: 'PEDIDOS DESPACHADOS'},
          {text: 'Cancelado', id: 'Cancelado', class: 'canceled', titulo: 'PEDIDOS CANCELADOS'}
        ],
        entregaComanda: undefined,
        fechaDesde: undefined,
        fechaHasta: undefined,
        idxDiaActivo: undefined,
        idxEstadoActivo: 0,
        estadoActivo: 'Recibido',
        verResumen: false
      }
    },
    methods: {
      abrirComanda (entrega) {
        const me = this
        me.entregaComanda = entrega
        $('#detalle-pedido').modal()
      },
      activarTablaPivot () {
        const me = this
        const $contenedor = $(me.$refs.contenedorPivor)
        $contenedor.html('')
        if (me.entregasFila.length === 0) {
          return false
        }
        $contenedor.pivotUI(me.entregasFila, {
          rows: ['plato'],
          cols: ['estado'],
          vals: ['cantidad'],
          aggregatorName: 'Sum'
        })
      },
      arrDistinct (arrArg) {
        return arrArg.filter(function (elem, pos, arr) {
          return arr.indexOf(elem) === pos
        })
      },
      cambiarEstadoPedidos (options) {
        const me = this
        me.$emit('activar-modal')
        me.$http.post('/api/restaurante/cambiarestado', options).then(({body}) => {
          const ids = body.ids
          me.entregas.forEach((entrega, idx) => {
            if (ids.includes(entrega._id)) {
              entrega.estado = body.estado
            }
          })
        }, (err) => {
          this.$emit('mostrar-notificacion', 'error', err)
        }).then(() => {
          me.entregas.push({})
          me.entregas.pop()
          me.entregas.forEach((entrega) => {
            entrega.seleccionada = false
          })
          me.$emit('cerrar-modal')
        })
      },
      entregasAEtiquetas (entregas) {
        const me = this
        if (entregas.length < 1) {
          me.$emit('mostrar-notificacion', 'No hay entregas seleccionadas', 'error')
          return
        }
        let datosEtiqueta = entregas.map((entrega) => {
          let restrictions = []
          entrega.usuario.celiac ? restrictions.push('Sin gluten') : null
          entrega.usuario.vegan ? restrictions.push('Vegano') : null
          entrega.usuario.vegetarian ? restrictions.push('Vegetariano') : null
          entrega.usuario.other ? restrictions.push('Otras') : null
          entrega.usuario.alergic ? restrictions.push('Alérgico') : null
          return {
            fecha: moment(entrega.fechaEntrega).format('DD/MM/YYYY'),
            hora: moment(entrega.fechaEntrega).format('HH:mm'),
            comensal: entrega.usuario.displayName,
            detalle: entrega.platosSerialized,
            empresa: entrega.sucursal.empresa.razonSocial + '-' + entrega.sucursal.denominacion,
            numero: entrega.numero,
            restricciones: restrictions.join(', '),
            direccion: entrega.sucursal.direccion.direccion
          }
        })
        me.imprimirEtiquetas(datosEtiqueta)
      },
      entregasListadoAPdf () {
        const me = this
        let entregas = me.entregasActivas
        if (entregas.length > 0) {
          entregas.forEach((entrega) => {
            entrega.fechaFormateada = moment(new Date(entrega.fechaEntrega)).format('DD/MM/YYYY HH:mm')
          })
          me.exportPfd(entregas, 'entregaslistado')
        } else {
          alert('No existen entregas en el listado')
        }
      },
      entregasSeleccionadasAPdf () {
        const me = this
        let entregas = me.entregasSeleccionadas
        if (entregas.length > 0) {
          entregas.forEach((entrega) => {
            entrega.fechaFormateada = moment(new Date(entrega.fechaEntrega)).format('DD/MM/YYYY HH:mm')
          })
          me.exportPfd(entregas, 'entregasseleccionadas')
        } else {
          alert('No hay entregas seleccionadas')
        }
      },
      entregasListadoAXls () {
        const me = this
        let entregas = me.entregasActivas
        if (entregas.length > 0) {
          me.exportXls(entregas, 'entregaslistado')
        } else {
          alert('No existen entregas en el listado')
        }
      },
      entregasSeleccionadasAXls () {
        const me = this
        let entregas = me.entregasSeleccionadas
        if (entregas.length > 0) {
          me.exportXls(entregas, 'entregasseleccionadas')
        } else {
          alert('No hay entregas seleccionadas')
        }
      },
      exportPfd (entregas, nombreArchivo = 'entregas') {
        const me = this
        var img = new Image()
        img.src = '/images/bird.png'
        img.onload = function () {
          let title = 'Pedidos para '
          if (me.filtroRestricciones !== 'ALL') {
            title = 'Pedidos con RESTRICCIONES ALIMENTARIAS '
          }
          if (me.empresaActiva !== '-1') {
            title += entregas[0].sucursal.empresa.razonSocial + ' ' + entregas[0].sucursal.denominacion
          } else {
            title += ' Todas las Empresas'
          }
          title += ' para el ' + moment(me.diaActivo).format('DD/MM/YYYY')
          const columns = ['Fecha', 'Usuario', 'Numero', 'Menu', 'Restricciones', 'Empresa']
          const rows = entregas.map((entrega) => {
            let restrictions = []
            entrega.usuario.celiac ? restrictions.push('Sin gluten') : null
            entrega.usuario.vegan ? restrictions.push('Vegano') : null
            entrega.usuario.vegetarian ? restrictions.push('Vegetariano') : null
            entrega.usuario.other ? restrictions.push('Otras') : null
            entrega.usuario.alergic ? restrictions.push('Alérgico') : null
            entrega.usuario.other || entrega.usuario.alergic ? restrictions.push(entrega.usuario.restrictions) : null
            return [
              entrega.fechaFormateada,
              entrega.usuario.displayName,
              entrega.numero,
              entrega.platosSerialized,
              restrictions.join(', '),
              entrega.sucursal.empresa.razonSocial + ' ' + entrega.sucursal.denominacion
            ]
          })
          const doc = new JsPDF('l')
          doc.autoTable(columns, rows, {
            margin: 25,
            bodyStyles: {
              overflow: 'visible',
              fontSize: 8,
              columnWidth: 'wrap'
            },
            headerStyles: {
              fillColor: [147, 165, 18]
            },
            addPageContent: function (data) {
              doc.addImage(img, 'PNG', 25, 10, 12, 12)
              doc.setFontSize(12)
              doc.text(title, 40, 18)
            }
          })
          doc.save(`${nombreArchivo}.pdf`)
        }
      },
      exportXls (entregas, nombreArchivo) {
        const me = this
        let title = 'Pedidos para '
        if (me.filtroRestricciones !== 'ALL') {
          title = 'Pedidos con RESTRICCIONES ALIMENTARIAS '
        }
        console.log(me.empresaActiva)
        if (me.empresaActiva !== '-1') {
          title += entregas[0].sucursal.empresa.razonSocial + ' ' + entregas[0].sucursal.denominacion
        } else {
          title += ' Todas las Empresas'
        }
        title += ' para el '
        let formattedDay = moment(me.diaActivo).format('DD/MM/YYYY')
        let html = `<table class="table" id="tblExport">
          <thead>
            <tr>
              <th colspan='5'>${title}</th>
              <th>${formattedDay}</th>
            </tr>
            <tr>
              <th>Fecha</th>
              <th>Usuario</th>
              <th>Numero</th>
              <th>Menu</th>
              <th>Restricciones</th>
              <th>Empresa</th>
            </tr>
          </thead>
          <tbody>
            ${entregas.map(entrega => {
              let restrictions = []
              entrega.usuario.celiac ? restrictions.push('Sin gluten') : null
              entrega.usuario.vegan ? restrictions.push('Vegano') : null
              entrega.usuario.vegetarian ? restrictions.push('Vegetariano') : null
              entrega.usuario.other ? restrictions.push('Otras') : null
              entrega.usuario.alergic ? restrictions.push('Alérgico') : null
              entrega.usuario.other || entrega.usuario.alergic ? restrictions.push(entrega.usuario.restrictions) : null
              return `<tr>
                <td>${entrega.fechaEntrega}</td>
                <td>${entrega.usuario.displayName}</td>
                <td>${entrega.numero}</td>
                <td>${entrega.platosSerialized}</td>
                <td>${restrictions.join(', ')}</td>
                <td>${entrega.sucursal.empresa.razonSocial}-${entrega.sucursal.denominacion}</td>
              </tr>`
            })
              }
          </tbody>
        </table>`
        $(me.$refs.contenedorExport).html(html)
        let table = document.getElementById('tblExport')
        let tableExp = new TableExport(table, {
          exportButtons: false,
          formats: ['xls', 'csv', 'txt', 'xlsx']
        })
        let exportData = tableExp.getExportData()
        tableExp.export2file(exportData.tblExport.xlsx.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', nombreArchivo, '.xlsx')
        // console.log(exportData.xls)
      },
      imprimirComandaGeneral () {
        let el = document.getElementById('body-comanda')
        PHE.printElement(el)
      },
      imprimirEtiquetas (etiquetas) {
        let styleAgregar = ''
        if (etiquetas.length < 25) {
          styleAgregar = 'height: 99%;'
        }
        let html = `<html>
        <head>
          <style>
            .contenedor:last-child {
                page-break-after: auto;
            }
            .item:last-child {
                page-break-after: auto;
            }
          </style>
        </head>
        <body style="page-break-before: none; page-break-after: none; page-break-inside: avoid; overflow:hidden; ${styleAgregar}">`
        html += '<div class="contenedor" style="width: 210mm; height: 296mm; clear:both; padding-top: 5mm;">'
        // let rec = 0
        etiquetas.forEach((etiqueta, idx) => {
          /*
          if (rec === 0) {
            html += `<div style="padding:0; margin: 0; width: 64mm; max-width: 64mm; max-height: 33.9m; height: 33.9mm; float:left;">`
          }
          */
          html += `<div class="item" style="padding:0; margin: 0; width: 65mm; max-width: 65mm; max-height: 33.9m; height: 33.9mm; float:left;">`
          html += `
              <div class="etiqueta-entrega" style="height: 33.9mm; margin-right: 3mm;">
                <div class="item fecha" style="font-size: 10px;">Nº ${etiqueta.numero} Fecha: ${etiqueta.fecha} ${etiqueta.hora}</div>
                <div class="item comensal" style="font-size: 11px;font-weight:bold;">${etiqueta.comensal}</div>
                <div class="item empresa" style="font-size: 9px; word-wrap: break-word;">${etiqueta.empresa} - ${etiqueta.direccion}</div>
                <div class="item empresa" style="font-size: 9px; word-wrap: break-word;">${etiqueta.restricciones}</div>
                <p class="item detalle" style="font-size: 9px; word-wrap: break-word;">${etiqueta.detalle}</p>
              </div>
            </div>
          `
          let comparador = idx + 1
          if (comparador > 1 && (comparador % 24) === 0) {
            html += `<div style="page-break-after: always;"></div>
            <div style="height: 5mm;"></div>
            `
          }
        })
        html += '</div></body></html>'
        // $('#contenedorEtiquetas').html(html)
        PHE.printHtml(html)
      },
      limpiarSeleccionados () {
        const me = this
        me.entregasActivas.forEach((entrega) => {
          entrega.seleccionada = false
        })
      },
      marcarTodos (hora, evt) {
        const valor = evt.target.checked
        const me = this
        me.entregasActivasEstado.forEach((entrega, idx) => {
          if (entrega.horaEntrega === hora) {
            entrega.seleccionada = valor
          }
        })
        me.entregas.push({})
        me.entregas.pop()
      },
      onChangeRestriccionesSeleccionados (e) {
        const me = this
        me.entregasActivas.forEach((entrega) => {
          entrega.seleccionada = false
        })
      },
      onChangeEstadoSeleccionados (e) {
        const me = this
        const estadoDestino = e.target.value
        const puedeCambiar = me.estadosHacia[me.estadoActivo].some((estado) => {
          return estado === estadoDestino
        })
        if (!puedeCambiar) {
          me.$emit('mostrar-notificacion', 'No se puede cambiar al estado seleccionado', 'error')
          return false
        }
        if (estadoDestino === 'Cancelado') {
          const confirmacion = confirm('Se cancelaran los pedidos, esta operación no es reversible. Presione Aceptar para confirmar la operación')
          if (!confirmacion) {
            return false
          }
        }
        if (me.entregasSeleccionadas.length > 0) {
          const ids = me.entregasSeleccionadas.map((entrega) => {
            return entrega._id
          })
          me.cambiarEstadoPedidos({
            ids: ids,
            estado: estadoDestino
          })
        } else {
          me.$emit('mostrar-notificacion', 'No hay entregas seleccionadas', 'error')
          return false
        }
      },
      onChangeItemEstado (options) {
        const me = this
        if (options.estado === 'Cancelado') {
          const confirmacion = confirm('Se cancelara el pedido, esta operación no es reversible. Presione Aceptar para confirmar la operación')
          if (!confirmacion) {
            return false
          }
        }
        let optionsCambiar = {
          ids: [options.entrega],
          estado: options.estado
        }
        me.cambiarEstadoPedidos(optionsCambiar)
      },
      printPivot () {
        let tabla = document.getElementsByClassName('pvtUi')[0]
        PHE.printElement(tabla)
      },
      setDiaActivo (idx) {
        this.diaActivo = this.dias[idx]
        this.idxDiaActivo = idx
        this.activarTablaPivot()
        this.limpiarSeleccionados()
      },
      setEstadoActivo (idx) {
        this.idxEstadoActivo = idx
        this.estadoActivo = this.estados[idx].id
      },
      /*
      showComandaDia () {
        const me = this
        let resumenComanda = me.comandaDelDia
      },
      */
      toggleSeleccion (id) {
        const me = this
        let entrega = me.entregas.find((entrega) => {
          return entrega._id === id
        })
        // entrega.seleccionada = !entrega.seleccionada
        let idx = me.entregas.indexOf(entrega)
        if (idx > -1) {
          me.entregas.splice(idx, 1, entrega)
        }
      }
    },
    mounted () {
      const me = this
      $('body').addClass('admin')
      me.$http.get('/api/restaurante/gestorpedidos').then(({body}) => {
        me.entregas = body.entregas
        me.entregas.forEach((entrega) => {
          entrega.seleccionada = false
          let platosArray = entrega.platos.map((plato) => {
            return `${plato.cantidad} ${plato.plato.nombre}`
          })
          let platosSerialized = platosArray.join(', ')
          entrega.platosSerialized = platosSerialized
        })
        let empresasAll = me.entregas.map((entrega) => {
          return {
            _id: entrega.sucursal._id,
            text: entrega.sucursal.empresa.razonSocial + ' ' + entrega.sucursal.denominacion
          }
        })
        let empresas = _.uniqBy(empresasAll, (empresa) => {
          return empresa._id
        })
        me.empresas = _.sortBy(empresas, ['text'])
        me.fechaDesde = body.fechas.desde
        me.fechaHasta = body.fechas.hasta
        me.dias = body.dias
      }, (err) => {
        console.log('error', err)
      }).then(() => {
        $(me.$refs.calendar_admin).owlCarousel({
          margin: 0,
          nav: true,
          slideBy: 6,
          loop: false,
          navText: ['<span />', '<span />'],
          responsive: {
            0: {
              items: 6
            }
          }
        })
        me.setDiaActivo(0)
        me.setEstadoActivo(0)
        $('[rel="tooltip"]').tooltip()
      })
    }
  }
</script>

<style scoped>
  .tabs-manager {
    max-width: 90%;
  }
  .tabs-manager li {
    display: inline-block;
    width: 17.9%;
    position: relative;
    bottom: -1px;
  }
  .col-hactions label{
    color:#3F3F3F;
    font-size:16px;
    font-weight:400;
    text-transform:initial;
  }
  .col-hactions.col3{
    width:auto;
  }
  .col-hactions.col3 .button {
    padding: 0;
    margin-top: 0;
  }
  .pvtFilterBox button {
    color: #101010;
  }
</style>



// WEBPACK FOOTER //
// GestorEntregas.vue?0428d452